module.exports = __webpack_public_path__ + "static/media/falcontorch-1.117e4137.jpg";